import axiosClient from "./axiosClient";

export const getDays = async () => {
  const response = await axiosClient.get("/Manager/Absence/GetDays");
  return response.data;
};